import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.slice.js";
import React from 'react';
import { Section } from '../../Section';
import { ArticleCard } from '../ArticleCard';
import { TagTitle, TagBlock, TagBottomBlock, Three } from './partials';
export var TopicGroupSection = function TopicGroupSection(_ref) {
  var title = _ref.title,
    tags = _ref.tags,
    _ref$smallQty = _ref.smallQty,
    smallQty = _ref$smallQty === void 0 ? 1 : _ref$smallQty,
    _ref$withTitle = _ref.withTitle,
    withTitle = _ref$withTitle === void 0 ? false : _ref$withTitle,
    _ref$bottomMargin = _ref.bottomMargin,
    bottomMargin = _ref$bottomMargin === void 0 ? false : _ref$bottomMargin;
  var mediumQty = 1;
  var sectionProps = withTitle ? {
    title: title,
    bottomMargin: bottomMargin
  } : {
    bottomMargin: bottomMargin
  };
  return React.createElement(Section, sectionProps, React.createElement(Three, null, tags.map(function (tag) {
    return React.createElement(TagBlock, {
      key: "tag-".concat(tag.id)
    }, React.createElement(TagTitle, null, tag.name), tag.articles.slice(0, mediumQty).map(function (article, index) {
      return React.createElement(ArticleCard, {
        key: index,
        variant: "medium",
        article: article,
        withAuthor: false,
        withDate: true
      });
    }), React.createElement(TagBottomBlock, null, tag.articles.slice(mediumQty, smallQty + mediumQty).map(function (article, index) {
      return React.createElement(ArticleCard, {
        key: index,
        variant: "small",
        article: article,
        withImage: true,
        withAuthor: false,
        withDate: true,
        imageFormat: "horizontal"
      });
    })));
  })));
};